// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValidationErrorColor {
    border-color: red !important;
}

.ValidationSuccessColor {
    border-color: #D5D5D5 !important;
}

.EditNotAllowed{
    cursor: not-allowed !important;
 }


.borderless-table{
    width:100% !important;
    margin-bottom: 5px !important;
}

.borderless-table tr td{
    border-top: none; 
    padding: 12px !important;
}
.cancel-button {
    font-size: 20px; 
    color: #165788; 
    cursor: pointer;
    margin-left: 5px;
}

.borderless-table > tr > td > input, select{
    width: 100% !important;
}

.borderless-table td{
    width: 25% !important;
}

.ui-widget input {
    width: 100% !important;
}

.grid-bg-primary {
    padding: 4px 2px 4px 3px !important;     
    vertical-align: middle;
    text-align: center !important;
}

.grid-button {
    font-size: 20px; 
    color: #165788; 
    cursor: pointer;
}

.grid-button-red {
    font-size: 20px; 
    color: red; 
    cursor: pointer;
    margin-left: 5px;
}

:host ::ng-deep .ui-panel .ui-panel-titlebar {
    display: none;
}

:host ::ng-deep .ui-panel-content-wrapper{
    border-top: 1px solid #D5D5D5 !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
    padding: 4px 2px 4px 3px !important;     
    vertical-align: middle;
}

:host ::ng-deep .p-datatable .p-datatable-frozen-view .p-datatable-tbody > tr > td,
.p-datatable .p-datatable-unfrozen-view .p-datatable-tbody > tr > td {
    height: 30px !important;
}

:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {
    height: 30px !important;
}

:host ::ng-deep .p-datatable .ui-editable-column input{
    font-size: 13px !important;
}

:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    box-shadow: 3px 3px 12px #165788;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header{
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;    
}
.different.p-dialog .ui-widget .p-dialog-header {
    display:none !important;
 }

 :host ::ng-deep .ui-button.ui-button-icon-only{
    width: 1.7em !important;
    height: 2.3em !important;
 }
 :host ::ng-deep body .ui-inputtext:enabled:focus:not(.ui-state-error) {
    border-color: #ea1212 !important;
    outline: 0 none;
    box-shadow: none; }

:host ::ng-deep select:disabled {   
        box-shadow: none!important;
        color: #858585 !important;
        background-color: #FFF;
        border: 1px solid #D5D5D5;
    }    
.ui-fieldset .ui-state-default {
    background: none;
    border:1px solid green;
    
}
/* .ui-fieldset-legend{
    width: 25% !important
} */
:host ::ng-deep .ui-fieldset-legend {
    display: block;
    width: 125px !important;
    padding: 0;
    margin-bottom: 10px !important;
    font-size: 15px !important;
    color: #333;
    border: 1px solid gray !important;    
    /* border-bottom: 1px solid #e5e5e5; */
}
:host ::ng-deep .ui-fieldset-legend-text{
    margin-left: 17% !important;
}
:host ::ng-deep .ui-fieldset {
    border: 1px solid #c8c8c8;
    background-color: #ffffff;
    color: #333333;
    border-radius: 10px;
}
:host ::ng-deep .ui-tree .ui-tree-container{
    max-height: 150px;
}
.col-1, .col-2,.col-3,.col-4,.col-5,.col-6,.col-7, .col-8,.col-9,.col-10,.col-11,.col-12
{
    float:left;
}
.card {
    max-height: 200px; 
    /* overflow: auto;  */
    height: 150px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
    transition: 0.3s;
    width: 350px;
    margin-left: 30px;
    overflow: hidden;

    
  }

  
  .boxed {
    /* border: 1px solid rgb(141, 121, 255) ; */
    
    background-color: #116fbf;
    width: 160px;
   
    /* margin-right: 30px; */
   
    padding: 10px;
    text-align: center;
    /* font-size: medium; */
    color: white;
  }


  /* Hierarchy Selection */
.activity-feed {
    padding: 15px;
  }
  .activity-feed .feed-item {
    position: relative;
    padding-bottom: 30px;
    padding-left: 30px;
    border-left: 1px solid #167588;
  }
  .activity-feed .feed-item:last-child {
    border-color: transparent;
  }
  .activity-feed .feed-item:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: -6px;
    width: 10px;
    height: 10px;
    border-radius: 6px;
    background: #fff;
    border: 2px solid #167588;
  }
  .activity-feed .feed-item .text {
    position: relative;
    top: -3px;
  }

  :host ::ng-deep  .p-dialog-footer{
    border: 0px !important;
}
  `, "",{"version":3,"sources":["webpack://./src/app/commonhelpers/user-profile/user-profile.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;CACjC;;;AAGD;IACI,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAG9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;AACA;IACI,uBAAuB;CAC1B;;CAEA;IACG,uBAAuB;IACvB,wBAAwB;CAC3B;CACA;IACG,gCAAgC;IAChC,eAAe;IAGf,gBAAgB,EAAE;;AAEtB;QACQ,0BAA0B;QAC1B,yBAAyB;QACzB,sBAAsB;QACtB,yBAAyB;IAC7B;AACJ;IACI,gBAAgB;IAChB,sBAAsB;;AAE1B;AACA;;GAEG;AACH;IACI,cAAc;IACd,uBAAuB;IACvB,UAAU;IACV,8BAA8B;IAC9B,0BAA0B;IAC1B,WAAW;IACX,iCAAiC;IACjC,sCAAsC;AAC1C;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;;IAEI,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,+GAA+G;IAC/G,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;;;EAGlB;;;EAGA;IACE,2CAA2C;;IAE3C,yBAAyB;IACzB,YAAY;;IAEZ,wBAAwB;;IAExB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;EACd;;;EAGA,wBAAwB;AAC1B;IACI,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;EAChC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;AAC1B","sourcesContent":[".ValidationErrorColor {\r\n    border-color: red !important;\r\n}\r\n\r\n.ValidationSuccessColor {\r\n    border-color: #D5D5D5 !important;\r\n}\r\n\r\n.EditNotAllowed{\r\n    cursor: not-allowed !important;\r\n }\r\n\r\n\r\n.borderless-table{\r\n    width:100% !important;\r\n    margin-bottom: 5px !important;\r\n}\r\n\r\n.borderless-table tr td{\r\n    border-top: none; \r\n    padding: 12px !important;\r\n}\r\n.cancel-button {\r\n    font-size: 20px; \r\n    color: #165788; \r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n.borderless-table > tr > td > input, select{\r\n    width: 100% !important;\r\n}\r\n\r\n.borderless-table td{\r\n    width: 25% !important;\r\n}\r\n\r\n.ui-widget input {\r\n    width: 100% !important;\r\n}\r\n\r\n.grid-bg-primary {\r\n    padding: 4px 2px 4px 3px !important;     \r\n    vertical-align: middle;\r\n    text-align: center !important;\r\n}\r\n\r\n.grid-button {\r\n    font-size: 20px; \r\n    color: #165788; \r\n    cursor: pointer;\r\n}\r\n\r\n.grid-button-red {\r\n    font-size: 20px; \r\n    color: red; \r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n:host ::ng-deep .ui-panel .ui-panel-titlebar {\r\n    display: none;\r\n}\r\n\r\n:host ::ng-deep .ui-panel-content-wrapper{\r\n    border-top: 1px solid #D5D5D5 !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n    padding: 4px 2px 4px 3px !important;     \r\n    vertical-align: middle;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-frozen-view .p-datatable-tbody > tr > td,\r\n.p-datatable .p-datatable-unfrozen-view .p-datatable-tbody > tr > td {\r\n    height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .p-datatable-tbody > tr > td {\r\n    height: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .p-datatable .ui-editable-column input{\r\n    font-size: 13px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header{\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;    \r\n}\r\n.different.p-dialog .ui-widget .p-dialog-header {\r\n    display:none !important;\r\n }\r\n\r\n :host ::ng-deep .ui-button.ui-button-icon-only{\r\n    width: 1.7em !important;\r\n    height: 2.3em !important;\r\n }\r\n :host ::ng-deep body .ui-inputtext:enabled:focus:not(.ui-state-error) {\r\n    border-color: #ea1212 !important;\r\n    outline: 0 none;\r\n    -webkit-box-shadow: none;\r\n    -moz-box-shadow: none;\r\n    box-shadow: none; }\r\n\r\n:host ::ng-deep select:disabled {   \r\n        box-shadow: none!important;\r\n        color: #858585 !important;\r\n        background-color: #FFF;\r\n        border: 1px solid #D5D5D5;\r\n    }    \r\n.ui-fieldset .ui-state-default {\r\n    background: none;\r\n    border:1px solid green;\r\n    \r\n}\r\n/* .ui-fieldset-legend{\r\n    width: 25% !important\r\n} */\r\n:host ::ng-deep .ui-fieldset-legend {\r\n    display: block;\r\n    width: 125px !important;\r\n    padding: 0;\r\n    margin-bottom: 10px !important;\r\n    font-size: 15px !important;\r\n    color: #333;\r\n    border: 1px solid gray !important;    \r\n    /* border-bottom: 1px solid #e5e5e5; */\r\n}\r\n:host ::ng-deep .ui-fieldset-legend-text{\r\n    margin-left: 17% !important;\r\n}\r\n:host ::ng-deep .ui-fieldset {\r\n    border: 1px solid #c8c8c8;\r\n    background-color: #ffffff;\r\n    color: #333333;\r\n    border-radius: 10px;\r\n}\r\n:host ::ng-deep .ui-tree .ui-tree-container{\r\n    max-height: 150px;\r\n}\r\n.col-1, .col-2,.col-3,.col-4,.col-5,.col-6,.col-7, .col-8,.col-9,.col-10,.col-11,.col-12\r\n{\r\n    float:left;\r\n}\r\n.card {\r\n    max-height: 200px; \r\n    /* overflow: auto;  */\r\n    height: 150px;\r\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\r\n    transition: 0.3s;\r\n    width: 350px;\r\n    margin-left: 30px;\r\n    overflow: hidden;\r\n\r\n    \r\n  }\r\n\r\n  \r\n  .boxed {\r\n    /* border: 1px solid rgb(141, 121, 255) ; */\r\n    \r\n    background-color: #116fbf;\r\n    width: 160px;\r\n   \r\n    /* margin-right: 30px; */\r\n   \r\n    padding: 10px;\r\n    text-align: center;\r\n    /* font-size: medium; */\r\n    color: white;\r\n  }\r\n\r\n\r\n  /* Hierarchy Selection */\r\n.activity-feed {\r\n    padding: 15px;\r\n  }\r\n  .activity-feed .feed-item {\r\n    position: relative;\r\n    padding-bottom: 30px;\r\n    padding-left: 30px;\r\n    border-left: 1px solid #167588;\r\n  }\r\n  .activity-feed .feed-item:last-child {\r\n    border-color: transparent;\r\n  }\r\n  .activity-feed .feed-item:after {\r\n    content: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: -6px;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 6px;\r\n    background: #fff;\r\n    border: 2px solid #167588;\r\n  }\r\n  .activity-feed .feed-item .text {\r\n    position: relative;\r\n    top: -3px;\r\n  }\r\n\r\n  :host ::ng-deep  .p-dialog-footer{\r\n    border: 0px !important;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
